<template>
    <span class="material-icons" :data-type="BT.BOT_RESPONSE" v-if="blockType === BT.BOT_RESPONSE"> send </span>
    <span class="material-icons" :data-type="BT.START_POINT" v-else-if="blockType === BT.START_POINT"> home </span>
    <span class="material-icons" :data-type="BT.ATTACHMENT_INPUT" v-else-if="blockType === BT.ATTACHMENT_INPUT">
        attachment
    </span>
    <span class="material-icons" :data-type="BT.FILTER" v-else-if="blockType === BT.FILTER"> filter_alt </span>
    <span class="material-icons" :data-type="BT.USER_INPUT" v-else-if="blockType === BT.USER_INPUT">
        record_voice_over
    </span>
    <span class="material-icons" :data-type="BT.GO_TO_STEP" v-else-if="blockType === BT.GO_TO_STEP"> cable </span>
    <span class="material-icons" :data-type="BT.ADD_TO_SEGMENT" v-else-if="blockType === BT.ADD_TO_SEGMENT">
        pie_chart
    </span>
    <span class="material-icons" :data-type="BT.REMOVE_FROM_SEGMENT" v-else-if="blockType === BT.REMOVE_FROM_SEGMENT">
        pie_chart
    </span>
    <span class="material-icons" :data-type="BT.DEFAULT_FALLBACK" v-else-if="blockType === BT.DEFAULT_FALLBACK">
        heart_broken
    </span>
    <span class="material-icons" :data-type="BT.FALLBACK" v-else-if="blockType === BT.FALLBACK"> heart_broken </span>
    <span class="material-icons" :data-type="BT.QUESTION" v-else-if="blockType === BT.QUESTION"> quiz </span>
    <span class="material-icons" :data-type="BT.SET_ATTRIBUTE" v-else-if="blockType === BT.SET_ATTRIBUTE">
        data_object
    </span>
    <span class="material-icons" :data-type="BT.ASSIGN_OWNER" v-else-if="blockType === BT.ASSIGN_OWNER">
        person_pin_circle
    </span>
    <span class="material-icons" :data-type="BT.CLOSE_CHAT" v-else-if="blockType === BT.CLOSE_CHAT">
        mark_chat_read
    </span>
    <span class="material-icons" :data-type="BT.SUCCESS" v-else-if="blockType === BT.SUCCESS"> check_circle </span>
    <span class="material-icons" :data-type="BT.FAILURE" v-else-if="blockType === BT.FAILURE"> cancel </span>
    <span class="material-icons" :data-type="BT.FLOW" v-else-if="blockType === BT.FLOW">schema</span>
    <span class="material-icons" :data-type="BT.PLATFORM_FLOW" v-else-if="blockType === BT.PLATFORM_FLOW">schema</span>
    <span class="material-icons" :data-type="BT.CREATE_TICKET" v-else-if="blockType === BT.CREATE_TICKET">
        local_activity
    </span>
    <span class="material-icons" :data-type="BT.TAG_CHAT" v-else-if="blockType === BT.TAG_CHAT"> bookmark </span>
    <span class="material-icons" :data-type="BT.REMOVE_TAG" v-else-if="blockType === BT.REMOVE_TAG">
        bookmark_remove
    </span>
    <span class="material-icons" :data-type="BT.TRANSFER_CHAT" v-else-if="blockType === BT.TRANSFER_CHAT">
        support_agent
    </span>
    <span class="material-icons" :data-type="BT.TRANSFER_TO_CHATBOT" v-else-if="blockType === BT.TRANSFER_TO_CHATBOT">
        fast_forward
    </span>
    <span class="material-icons" :data-type="BT.SEND_TRANSCRIPT" v-else-if="blockType === BT.SEND_TRANSCRIPT">
        attach_email
    </span>
    <span class="material-icons" :data-type="BT.SEND_SMS" v-else-if="blockType === BT.SEND_SMS"> sms </span>
    <span class="material-icons" :data-type="BT.SEND_MAIL" v-else-if="blockType === BT.SEND_MAIL"> mail </span>
    <span class="material-icons" :data-type="BT.CREATE_EVENT" v-else-if="blockType === BT.CREATE_EVENT"> event </span>
    <span class="material-icons" :data-type="BT.CREATE_RESERVATION" v-else-if="blockType === BT.CREATE_RESERVATION">
        calendar_month
    </span>
    <span class="material-icons" :data-type="BT.RESERVATION_OPEN_URL" v-else-if="blockType === BT.RESERVATION_OPEN_URL">
        event
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_SELECT_DAY"
        v-else-if="blockType === BT.RESERVATION_SELECT_DAY"
    >
        calendar_month
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_EVENT_LIST"
        v-else-if="blockType === BT.RESERVATION_EVENT_LIST"
    >
        event_note
    </span>
    <span
        class="material-icons"
        :data-type="BT.RESERVATION_SELECT_TIME"
        v-else-if="blockType === BT.RESERVATION_SELECT_TIME"
    >
        calendar_month
    </span>
    <span class="material-icons text-light" :data-type="BT.WEBHOOK" v-else-if="blockType === BT.WEBHOOK"> share </span>
    <span class="material-icons text-light" :data-type="BT.API_REQUEST" v-else-if="blockType === BT.API_REQUEST">
        share
    </span>
    <span class="material-icons" :data-type="BT.GET_LOCATION" v-else-if="blockType === BT.GET_LOCATION">
        location_on
    </span>
    <span class="material-icons" :data-type="BT.SET_DEPARTMENT" v-else-if="blockType === BT.SET_DEPARTMENT">
        category
    </span>
    <span class="material-icons" :data-type="BT.TAVILY_WEB_SEARCH" v-else-if="blockType === BT.TAVILY_WEB_SEARCH">
        search
    </span>
    <span class="material-icons" :data-type="BT.OPENAI_WEB_SEARCH" v-else-if="blockType === BT.OPENAI_WEB_SEARCH">
        search
    </span>
    <img
        class="custom-block-logo"
        src="/static/img/akinon.png"
        :data-type="blockType"
        v-else-if="BT.AKINON_BLOCKS.includes(blockType)"
    />
    <img
        class="custom-block-logo"
        src="/static/img/ideasoft.webp"
        :data-type="blockType"
        v-else-if="BT.IDEASOFT_BLOCKS.includes(blockType)"
    />

    <img
        class="custom-block-logo"
        src="/static/img/chatbot/probel.png"
        :data-type="blockType"
        v-else-if="BT.PROBEL_BLOCKS.includes(blockType)"
    />

    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BT.SHOPIFY_ORDER_STATUS"
        v-else-if="blockType === BT.SHOPIFY_ORDER_STATUS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BT.SHOPIFY_PRODUCT_AVAILABILITY"
        v-else-if="blockType === BT.SHOPIFY_PRODUCT_AVAILABILITY"
    />
    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BT.SHOPIFY_SHOW_PRODUCTS"
        v-else-if="blockType === BT.SHOPIFY_SHOW_PRODUCTS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/openai.png"
        :data-type="BT.AI_BOT_RESPONSE"
        v-else-if="blockType === BT.AI_BOT_RESPONSE || blockType === BT.AI_FUNCTIONS"
    />
    <div class="custom-block-logo ai-assistant" v-else-if="blockType === BT.AI_ASSISTANT" :data-type="BT.AI_ASSISTANT">
        <OpenaiIcon />
    </div>
    <div
        class="custom-block-logo ai-assistant"
        v-else-if="blockType === BT.FEEDBACK_AI_ASSISTANT"
        :data-type="BT.FEEDBACK_AI_ASSISTANT"
    >
        <OpenaiIcon />
    </div>
    <div
        class="custom-block-logo ai-assistant"
        v-else-if="blockType === BT.INSERT_TO_SYSTEM_PROMPT"
        :data-type="BT.INSERT_TO_SYSTEM_PROMPT"
    >
        <OpenaiIcon />
    </div>
    <span class="material-icons" :data-type="BT.CREATE_TASK" v-else-if="blockType === BT.CREATE_TASK"> add_task </span>
    <span class="material-icons" :data-type="BT.SUPPRESSION_ADD" v-else-if="blockType === BT.SUPPRESSION_ADD">
        block
    </span>
    <span class="material-icons" :data-type="BT.SUPPRESSION_REMOVE" v-else-if="blockType === BT.SUPPRESSION_REMOVE">
        lock_open
    </span>
    <img
        class="custom-block-logo"
        src="/static/img/chatbot/b2cargo.png"
        :data-type="BT.B2CARGO_PRODUCT_STATUS"
        v-else-if="blockType === BT.B2CARGO_PRODUCT_STATUS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/chatbot/b2cargo.png"
        :data-type="BT.B2CARGO_LOGIN_USER"
        v-else-if="blockType === BT.B2CARGO_LOGIN_USER"
    />
    <span class="material-icons" :data-type="BT.DEFAULT_TIMEOUT" v-else-if="blockType === BT.DEFAULT_TIMEOUT">
        timer
    </span>
    <span class="material-icons" :data-type="BT.TIMEOUT" v-else-if="blockType === BT.TIMEOUT"> timer </span>
    <span
        class="material-icons"
        :data-type="BT.SEND_WP_BUSINESS_MESSAGE"
        v-else-if="blockType === BT.SEND_WP_BUSINESS_MESSAGE"
    >
        send
    </span>
    <span
        class="material-icons"
        :data-type="BT.MESSENGER_SEND_MESSAGE"
        v-else-if="blockType === BT.MESSENGER_SEND_MESSAGE"
    >
        send
    </span>
    <span
        class="material-icons"
        :data-type="BT.INSTAGRAM_SEND_MESSAGE"
        v-else-if="blockType === BT.INSTAGRAM_SEND_MESSAGE"
    >
        send
    </span>

    <img
        class="custom-block-logo"
        src="/static/img/chatbot/b2cargo.png"
        :data-type="BT.B2CARGO_LOGIN_USER"
        v-else-if="blockType === BT.B2CARGO_LOGIN_USER"
    />
    <img
        class="custom-block-logo"
        src="/static/img/chatbot/holidayplus.png"
        :data-type="BT.HOLIDAY_PLUS_GET_HOTELS"
        v-else-if="blockType === BT.HOLIDAY_PLUS_GET_HOTELS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/chatbot/holidayplus.png"
        :data-type="BT.HOLIDAY_PLUS_GET_ROOMS"
        v-else-if="blockType === BT.HOLIDAY_PLUS_GET_ROOMS"
    />
    <ZohoIcon class="material-icons zoho" :data-type="blockType" v-else-if="blockType.startsWith('ZOHO')" />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_REPLY"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_REPLY"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_DELETE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_DELETE"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_SHOW"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_SHOW"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_HIDE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_HIDE"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.AI_INSTAGRAM_FLOW"
        v-else-if="blockType === BT.AI_INSTAGRAM_FLOW"
    />
    <InstagramIcon
        class="custom-block-logo"
        :data-type="BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"
        v-else-if="blockType === BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"
    />
    <AIClassificationIcon
        class="custom-block-logo"
        :data-type="BT.AI_MENU_FLOW"
        v-else-if="blockType === BT.AI_MENU_FLOW"
    />
    <AIClassificationIcon
        class="custom-block-logo"
        :data-type="BT.AI_CLASSIFICATION"
        v-else-if="blockType === BT.AI_CLASSIFICATION"
    />
    <TsoftIcon
        class="custom-block-logo"
        style="width: 30px"
        v-else-if="blockType === BT.TSOFT_ORDER_STATUS || blockType === BT.TSOFT_SELECT_ORDER"
        :data-type="BT.TSOFT_ORDER_STATUS"
    />
    <IkasIcon
        class="custom-block-logo"
        style="width: 30px"
        :data-type="blockType"
        v-else-if="BT.IKAS_BLOCKS && BT.IKAS_BLOCKS.includes(blockType)"
    />
    <TicimaxIcon
        class="custom-block-logo"
        style="width: 30px"
        :data-type="blockType"
        v-else-if="BT.TICIMAX_V2_BLOCKS && BT.TICIMAX_V2_BLOCKS.includes(blockType)"
    />
    <span class="material-icons" :data-type="BT.OTP_WHATSAPP_FLOW" v-else-if="blockType === BT.OTP_WHATSAPP_FLOW">
        sms
    </span>
    <span class="material-icons" :data-type="BT.OTP_SMS_FLOW" v-else-if="blockType === BT.OTP_SMS_FLOW"> sms </span>
    <span class="material-icons" :data-type="BT.OTP_MAIL_FLOW" v-else-if="blockType === BT.OTP_MAIL_FLOW"> mail </span>

    <span class="material-icons" :data-type="BT.TABLE_CREATE_RECORD" v-else-if="blockType === BT.TABLE_CREATE_RECORD">
        add_circle
    </span>
    <span class="material-icons" :data-type="BT.TABLE_UPDATE_RECORD" v-else-if="blockType === BT.TABLE_UPDATE_RECORD">
        edit
    </span>
    <span class="material-icons" :data-type="BT.TABLE_DELETE_RECORD" v-else-if="blockType === BT.TABLE_DELETE_RECORD">
        delete
    </span>
    <span class="material-icons" :data-type="BT.TABLE_FIND_RECORD" v-else-if="blockType === BT.TABLE_FIND_RECORD">
        search
    </span>
    <span class="material-icons" :data-type="BT.TABLE_FIND_RECORDS" v-else-if="blockType === BT.TABLE_FIND_RECORDS">
        list
    </span>
    <span class="material-icons voice-agent-icon" :data-type="BT.AI_CALL" v-else-if="blockType === BT.AI_CALL">
        record_voice_over
    </span>
    <span class="material-icons" :data-type="BT.RUN_JAVASCRIPT" v-else-if="blockType === BT.RUN_JAVASCRIPT">
        code
    </span>
    
    <span class="material-icons" :data-type="BT.CACHE_WRITE" v-else-if="blockType === BT.CACHE_WRITE">
        save
    </span>
    <span class="material-icons" :data-type="BT.CACHE_READ" v-else-if="blockType === BT.CACHE_READ">
        download
    </span>
    <span class="material-icons" :data-type="BT.CACHE_EXTEND" v-else-if="blockType === BT.CACHE_EXTEND">
        update
    </span>
    <span class="material-icons" :data-type="BT.CACHE_DELETE" v-else-if="blockType === BT.CACHE_DELETE">
        delete_forever
    </span>
    
    <span 
        class="material-icons custom-block-icon" 
        :data-type="BT.CUSTOM_BLOCK" 
        v-else-if="blockType === BT.CUSTOM_BLOCK"
    >
        {{ customBlockIcon || "extension" }}
    </span>
</template>

<script>
import BT from "../../../block.types";
import OpenaiIcon from "../../integrations/svg/OpenaiIcon.vue";
import InstagramIcon from "../../integrations/svg/InstagramIcon.vue";
import WhatsappIcon from "../../integrations/svg/WhatsappIcon.vue";
import AIClassificationIcon from "../../../../../../components/svg/icons/AIClassificationIcon.vue";
import ZohoIcon from "../../integrations/svg/ZohoIcon.vue";
import TsoftIcon from "../../integrations/svg/TsoftIcon.vue";
import IkasIcon from "../../integrations/svg/IkasIcon.vue";
import TicimaxIcon from "../../integrations/svg/TicimaxIcon.vue";

export default {
    name: "BlockIconPreview",
    components: {
        ZohoIcon,
        WhatsappIcon,
        OpenaiIcon,
        AIClassificationIcon,
        InstagramIcon,
        TsoftIcon,
        IkasIcon,
        TicimaxIcon,
    },
    props: {
        blockType: {
            type: String,
            required: false,
            default: "",
        },
        customBlockIcon: {
            type: String,
            required: false,
            default: null,
        },
    },
    data: function () {
        return {
            BT,
        };
    },
};
</script>

<style lang="scss">
.material-icons {
    &.voice-agent-icon {
        background: linear-gradient(135deg, #ff6b6b, #4ecdc4, #45b7d1, #96c93d, #ffbe0b);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        animation: rainbow 5s ease infinite;
    }
    &.zoho {
        width: 30px;
        height: 20px;
    }
    &[data-type="BOT_RESPONSE"] {
        transform: rotate(-40deg);
    }

    &[data-type="FLOW"] {
        transform: rotate(180deg);
    }

    &[data-type="ATTACHMENT_INPUT"] {
        transform: rotate(-45deg);
    }

    &[data-type="GO_TO_STEP"] {
        color: red;
        transform: rotate(87deg);
    }

    &[data-type="ADD_TO_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="REMOVE_FROM_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="SET_DEPARTMENT"] {
        color: white;
        background-color: #f30879 !important;
        border-radius: 50%;
        padding: 2px;
    }
}

svg[data-type="AI_CLASSIFICATION"] {
    width: 40px;
}

.custom-block-logo {
    background: none !important;

    &[data-type="AI_ASSISTANT"],
    &[data-type="FEEDBACK_AI_ASSISTANT"],
    &[data-type="INSERT_TO_SYSTEM_PROMPT"]{
        border-radius: 50%;
        padding: 2px;

        svg {
            width: 20px;
            height: 20px;
            fill: #fff;

            g {
                fill: #fff !important;
            }
        }
    }
}
</style>
